import { EMPTY_LIST } from '../../../../constants/common'
import { getNextMultiValue } from '../../../../utils/formHelpers'
import { EmailRecipientsField } from '../../../Email'
import { FormBody } from '../../../Form'
import { FormikField, FormikForm } from '../../../Formik'
import { Container } from '../../Container'

import * as styles from './EmailsRecipients.module.css'

function EmailsRecipients() {
  return (
    <>
      <Container
        label='Email recipients field'
        style={{
          background: 'var(--color-bg-surface)',
          padding: '24px',
          width: '960px',
        }}
      >
        <FormikForm
          formProps={{
            style: { width: '100%' },
          }}
          initialValues={{
            select: EMPTY_LIST,
          }}
          onSubmit={() => {}}
        >
          <FormBody
            actionsProps={{
              cancelProps: {
                onClick: () => {},
              },
              withUpload: false,
            }}
          >
            <FormikField
              showLabel
              viewBcc
              viewCc
              Component={EmailRecipientsField}
              fieldComponentProps={{
                fieldInputClassName: styles.field,
                label: 'select field',
                labelClassName: styles.label,
              }}
              getNextValue={(value, prevValue) =>
                getNextMultiValue(prevValue, value, option => option.id)
              }
              name='select'
            />
          </FormBody>
        </FormikForm>
      </Container>
    </>
  )
}

export default EmailsRecipients
